import fillSum from './fill_sum'

export default function fillSumPlus(content = 'asda{Ⓐ}', expression = '|Ⓐ/B=C,Ⓐ=-4;B=3;C=#|', defaultKeys = null) {
  console.log(content, expression)
  // 取出变量映射数据
  let [variMapData, pattern] = fillSum(expression, defaultKeys, false, true),
  newCte = content
  console.log(variMapData)
  for(let key in variMapData) {
    let val = variMapData[key]
    
    if(newCte.indexOf(`{${key}}`) > -1) {
      newCte = newCte.replaceAll(`{${key}}`, val.value || val)
    }
  }

  console.log(newCte, pattern)

  return {newCte, pattern}
}